/* eslint-disable */
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const OrganizerNotificationsDocument = gql`
    query OrganizerNotifications($page: Int!, $limit: Int!) {
  organizerNotifications(page: $page, limit: $limit) {
    items {
      id
      message
      wasRead
      createdAt
    }
    page
    maxPage
    unreadCount
  }
}
    `;

/**
 * __useOrganizerNotificationsQuery__
 *
 * To run a query within a React component, call `useOrganizerNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizerNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizerNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrganizerNotificationsQuery(baseOptions: Apollo.QueryHookOptions<OrganizerNotificationsQuery, OrganizerNotificationsQueryVariables> & ({ variables: OrganizerNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizerNotificationsQuery, OrganizerNotificationsQueryVariables>(OrganizerNotificationsDocument, options);
      }
export function useOrganizerNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizerNotificationsQuery, OrganizerNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizerNotificationsQuery, OrganizerNotificationsQueryVariables>(OrganizerNotificationsDocument, options);
        }
export function useOrganizerNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizerNotificationsQuery, OrganizerNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizerNotificationsQuery, OrganizerNotificationsQueryVariables>(OrganizerNotificationsDocument, options);
        }
export type OrganizerNotificationsQueryHookResult = ReturnType<typeof useOrganizerNotificationsQuery>;
export type OrganizerNotificationsLazyQueryHookResult = ReturnType<typeof useOrganizerNotificationsLazyQuery>;
export type OrganizerNotificationsSuspenseQueryHookResult = ReturnType<typeof useOrganizerNotificationsSuspenseQuery>;
export type OrganizerNotificationsQueryResult = Apollo.QueryResult<OrganizerNotificationsQuery, OrganizerNotificationsQueryVariables>;
export const ReadOrganizerNotificationDocument = gql`
    mutation ReadOrganizerNotification($id: Int!) {
  readOrganizerNotification(id: $id)
}
    `;
export type ReadOrganizerNotificationMutationFn = Apollo.MutationFunction<ReadOrganizerNotificationMutation, ReadOrganizerNotificationMutationVariables>;

/**
 * __useReadOrganizerNotificationMutation__
 *
 * To run a mutation, you first call `useReadOrganizerNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizerNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readOrganizerNotificationMutation, { data, loading, error }] = useReadOrganizerNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadOrganizerNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadOrganizerNotificationMutation, ReadOrganizerNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadOrganizerNotificationMutation, ReadOrganizerNotificationMutationVariables>(ReadOrganizerNotificationDocument, options);
      }
export type ReadOrganizerNotificationMutationHookResult = ReturnType<typeof useReadOrganizerNotificationMutation>;
export type ReadOrganizerNotificationMutationResult = Apollo.MutationResult<ReadOrganizerNotificationMutation>;
export type ReadOrganizerNotificationMutationOptions = Apollo.BaseMutationOptions<ReadOrganizerNotificationMutation, ReadOrganizerNotificationMutationVariables>;
export const RemoveOrganizerNotificationDocument = gql`
    mutation RemoveOrganizerNotification($id: Int!) {
  removeOrganizerNotification(id: $id)
}
    `;
export type RemoveOrganizerNotificationMutationFn = Apollo.MutationFunction<RemoveOrganizerNotificationMutation, RemoveOrganizerNotificationMutationVariables>;

/**
 * __useRemoveOrganizerNotificationMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizerNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizerNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizerNotificationMutation, { data, loading, error }] = useRemoveOrganizerNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrganizerNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganizerNotificationMutation, RemoveOrganizerNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganizerNotificationMutation, RemoveOrganizerNotificationMutationVariables>(RemoveOrganizerNotificationDocument, options);
      }
export type RemoveOrganizerNotificationMutationHookResult = ReturnType<typeof useRemoveOrganizerNotificationMutation>;
export type RemoveOrganizerNotificationMutationResult = Apollo.MutationResult<RemoveOrganizerNotificationMutation>;
export type RemoveOrganizerNotificationMutationOptions = Apollo.BaseMutationOptions<RemoveOrganizerNotificationMutation, RemoveOrganizerNotificationMutationVariables>;
export const ClearAllOrganizerNotificationsDocument = gql`
    mutation ClearAllOrganizerNotifications {
  clearAllOrganizerNotifications
}
    `;
export type ClearAllOrganizerNotificationsMutationFn = Apollo.MutationFunction<ClearAllOrganizerNotificationsMutation, ClearAllOrganizerNotificationsMutationVariables>;

/**
 * __useClearAllOrganizerNotificationsMutation__
 *
 * To run a mutation, you first call `useClearAllOrganizerNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllOrganizerNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllOrganizerNotificationsMutation, { data, loading, error }] = useClearAllOrganizerNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearAllOrganizerNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ClearAllOrganizerNotificationsMutation, ClearAllOrganizerNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAllOrganizerNotificationsMutation, ClearAllOrganizerNotificationsMutationVariables>(ClearAllOrganizerNotificationsDocument, options);
      }
export type ClearAllOrganizerNotificationsMutationHookResult = ReturnType<typeof useClearAllOrganizerNotificationsMutation>;
export type ClearAllOrganizerNotificationsMutationResult = Apollo.MutationResult<ClearAllOrganizerNotificationsMutation>;
export type ClearAllOrganizerNotificationsMutationOptions = Apollo.BaseMutationOptions<ClearAllOrganizerNotificationsMutation, ClearAllOrganizerNotificationsMutationVariables>;
export type OrganizerNotificationsQueryVariables = Types.Exact<{
  page: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
}>;


export type OrganizerNotificationsQuery = { __typename?: 'Query', organizerNotifications: { __typename?: 'OrganizerNotificationPaginatedType', page: number, maxPage: number, unreadCount: number, items: Array<{ __typename?: 'OrganizerNotificationType', id: number, message: string, wasRead: boolean, createdAt?: string | null }> } };

export type ReadOrganizerNotificationMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ReadOrganizerNotificationMutation = { __typename?: 'Mutation', readOrganizerNotification: boolean };

export type RemoveOrganizerNotificationMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type RemoveOrganizerNotificationMutation = { __typename?: 'Mutation', removeOrganizerNotification: boolean };

export type ClearAllOrganizerNotificationsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ClearAllOrganizerNotificationsMutation = { __typename?: 'Mutation', clearAllOrganizerNotifications: boolean };
